import { useState, useRef, useEffect } from "react";
import styles from "./Dropdown.module.css";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

interface DropdownProps {
  label?: string;
  options: string[];
  selectedValue?: string;
  onSelect: (value: string) => void;
  placeholder?: string;
}

export default function Dropdown({
  label,
  options,
  selectedValue,
  onSelect,
  placeholder = "Selecione",
}: DropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const isDefault = selectedValue === options[0];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (value: string) => {
    onSelect(value);
    setIsOpen(false);
  };

  const displayValue = selectedValue || placeholder;

  return (
    <div className={styles.dropdownWrapper} ref={dropdownRef}>
      {label && <div className={styles.labelSelect}>{label}</div>}
      <div
        className={`${styles.select} ${isOpen ? styles.selectOpen : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span
          className={`${styles.selectLabel} ${
            selectedValue && !isDefault ? styles.selectLabelSelected : ""
          } ${isOpen ? styles.selectLabelOpen : ""}`}
        >
          {displayValue}
        </span>
        {isOpen ? (
          <UpOutlined
            style={{ fontSize: "14px", color: "rgba(111, 111, 118, 1)" }}
          />
        ) : (
          <DownOutlined
            style={{ fontSize: "14px", color: "rgba(111, 111, 118, 1)" }}
          />
        )}
      </div>
      {isOpen && (
        <div className={styles.dropdownMenu}>
          {options.filter(option => option !== selectedValue).map((option, index) => (
            <div
              key={index}
              className={styles.dropdownItem}
              onClick={() => handleSelect(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
